// @declaration: true
import { Cell } from './Cell';
import { HiddenCellProperties } from './HiddenCellProperties';
import { CellProperties } from '../models/CellProperties';

export interface BuilderTask {
  header: Description;
  description: Description;
  print: Print;
  handlers: Handlers;
  hiddenCells: HiddenCell[];
  tabs: Tab[];
  uiActions: any[];
  model: any;
}
export class BuilderControl implements Row, Cell, Section {
  public columns: number = null;
  public decoration: string = null;
  public rows: Row[] = null;
  public showlabel: boolean = null;
  public visible?: string = null;
  public cells: any = null;
  public colSpan: number = null;
  public properties?: CellProperties = null;
  public name?: string = null;
  public rowSpan: number = null;
  public showHelp: boolean = null;
  public title?: string = null;
  public event?: string = null;
  public fieldType?: never;
}
export interface Description {
  title?: string;
}

export interface Handlers {
  onloadscript: string;
}

export interface HiddenCell {
  colSpan: number;
  name: string;
  rowSpan: number;
  showHelp: boolean;
  title?: string;
  properties?: HiddenCellProperties;
}

export interface Print {}

export interface Tab {
  name: string;
  sections: Section[];
  title?: string;
}

export interface Section {
  columns: number;
  decoration: string;
  name?: string;
  rows: Row[];
  showlabel: boolean;
  title?: string;
  visible?: string;
}
export interface Row {
  cells: Cell[] | any;
}

export interface BuilderModel {
  primaryKey: string;
  header: string;
  description: string;
  dataSource: DataSource;
  fieldCollection: BuilderField[];
  name: string;
  version: string;
}

export interface DataSource {
  dataSourceType: string;
  name: string;
  sqlView: string;
}

export class BuilderField {
  constructor(
    public name: string = '',
    public title: string = '',
    public fieldType: string | number = '',
    public designCategory?: string,
    public iconClass?: string,
    public dbTypeName: string = 'StringUnicode',
    public format: string = '',
    public description: string = '',
    public maxLength: string = '',
    public isSystemRequired: boolean = false,
    public readonly: boolean = false,
    public uiMask: string = '00111',
    public bindings?: any[],
    public isHidden: boolean = false,
    public isRequiredForGrid: boolean = false,
    public isRequiredForForm: boolean = false,
    public isValidForGrid: boolean = false,
    public isValidForForm: boolean = false,
    public allowCreate: boolean = false,
    public isValidForReport: boolean = false,
    public isExtractable: boolean = false,
    public isSingleLookup: boolean = false,
    public isDynamicDropDown: boolean = false,
    public isNonValueType: boolean = false,
    public hasRelation: boolean = false,
    public rows?: any[],
    public options?: any[],
    public isMultiple?: boolean,
    public decoration?: string,
    public columns?: number,
  ) {}
}
